import type { Fetcher } from 'swr';
import useSWR from 'swr';

import { consultantsCustomerAccountsList } from '~/data/generated/endpoints/consultants/consultants';
import type { CustomerAccount } from '~/data/generated/model';

const customerAccountsFetcher: Fetcher<
  CustomerAccount[],
  readonly ['customer-accounts']
> = async () => {
  try {
    const { data } = await consultantsCustomerAccountsList();
    return data;
  } catch (error) {
    console.error('Error fetching customer accounts:', error);
    // Return empty array if endpoint doesn't exist yet
    return [];
  }
};

export type UseCustomerAccountsHook = {
  customerAccounts: CustomerAccount[] | undefined;
  isLoading: boolean;
  error: unknown;
};

/**
 * Returns all customer accounts available to the authenticated user.
 */
export default function useCustomerAccounts(enabled = true): UseCustomerAccountsHook {
  const { data, error, isLoading } = useSWR(
    enabled ? (['customer-accounts'] as const) : null,
    customerAccountsFetcher,
  );

  return {
    customerAccounts: data || [],
    isLoading: isLoading,
    error,
  };
}
